<template>
  <div>
    <div class="row mb-2">
      <div class="col-12" align="right">
        <button class="btn btn-add" @click="importarPrioridades()">
          Importar Prioridades do SIGAP
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Prioridades"
          newText="Nova Prioridade"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
          :key="reload"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      reload: 0,
      table: "prioritiesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "title",
        "status",
        "prefix",
        "sigap_priority_id",
        "value",
        "integration_value",
        "max_attendance_time_minutes",
        "actions",
      ],
      tableData: [
        "id",
        "title",
        "status",
        "prefix",
        "sigap_priority_id",
        "value",
        "integration_value",
        "max_attendance_time_minutes",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "title",
          "status",
          "prefix",
          "sigap_priority_id",
          "value",
          "integration_value",
          "max_attendance_time_minutes",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Titulo",
          status: "Status",
          prefix: "Prefixo",
          sigap_priority_id: "ID SIGAP",
          value: "Valor",
          integration_value: "Valor de Integração",
          max_attendance_time_minutes: "Tempo Máx. (min)",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "priorities",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        status: "status",
        prefix: "prefix",
        sigap_priority_id: "sigap_priority_id",
        value: "value",
        integration_value: "integration_value",
        max_attendance_time_minutes: "max_attendance_time_minutes",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    importarPrioridades: function () {
      const self = this;
      const api = self.$store.state.api + "priorities-from-sigap/";

      self.$loading(true);
      axios
        .get(api)
        .then(() => {
          self.$loading(false);
          self.$message(
            "Sucesso",
            "Prioridades importadas com sucesso",
            "success"
          );
          self.$refs.usersCrud.getData();
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
